import { render, staticRenderFns } from "./EventDetailComponent.vue?vue&type=template&id=05082638&scoped=true"
import script from "./EventDetailComponent.vue?vue&type=script&lang=js"
export * from "./EventDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05082638",
  null
  
)

export default component.exports